import React from 'react'
import { Header, Content, Footer } from './index'
import { homeRoutes } from '../routes/index'

function Home() {
  return (
    <>
      <Header />
      <Content routes={homeRoutes} />
      <Footer />
    </>
  )
}

export default Home
